import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import util from './utils/util'
import VueClipboard from 'vue-clipboard2'

const DOMAIN_CONFIG = require('./utils/domainConfig')

// 根据域名区分登录页面
const currentDomain = window.location.hostname
const isOverseasDomain = currentDomain === DOMAIN_CONFIG.OVERSEAS_DOMAIN
const isDomesticDomain = currentDomain === DOMAIN_CONFIG.DOMESTIC_DOMAIN

// 动态设置 title
const titleMap = {
  [DOMAIN_CONFIG.OVERSEAS_DOMAIN]: 'BlueX 开发者平台',
  [DOMAIN_CONFIG.DOMESTIC_DOMAIN]: '多盟开发者平台'
}
document.title = titleMap[currentDomain] || titleMap[DOMAIN_CONFIG.DOMESTIC_DOMAIN]

// 动态设置 favicon
const faviconMap = {
  [DOMAIN_CONFIG.OVERSEAS_DOMAIN]: '/abroadFavicon.ico',
  [DOMAIN_CONFIG.DOMESTIC_DOMAIN]: '/favicon.ico'
}
const icon = faviconMap[currentDomain] || faviconMap[DOMAIN_CONFIG.DOMESTIC_DOMAIN]

const oldLink = document.querySelector("link[rel*='icon']")
if (oldLink) {
  oldLink.remove()
}
const link = document.createElement('link')
link.type = 'image/x-icon'
link.rel = 'icon'
link.href = icon
document.head.appendChild(link)

// 配置路由重定向
router.beforeEach((to, from, next) => {
  // 如果是访问根路径，根据域名重定向到对应登录页面
  if (to.path === '/' && !util.getCookie('token')) {
    if (isOverseasDomain) {
      next('/login-overseas');
    } else if (isDomesticDomain) {
      next('/login-domestic');
    } else {
      // 默认情况到国内登录页
      next('/login-domestic');
    }
    return;
  }
  next();
});


import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'

import './utils';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/color-dark.css";
import "./assets/css/main.css";
import './assets/css/icon.css';
import i18n from '@/i18n/index'
import list from '@/utils/commonList'
import './utils/icon';


Vue.prototype.$eventBus = new Vue()
Vue.config.productionTip = false;

Vue.prototype.$com = list
// Vue.component('downloadExcel', JsonExcel)
Vue.component('chart', ECharts)

// 全局注册子应用通信方法
window.mainAppRouter = router

Vue.use(ElementUI, { size: 'small' });
Vue.use(VueClipboard);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#dp_push')


